import {
    Component,
    OnInit,
    Inject,
    Input,
    ViewChild,
    Output,
    EventEmitter,
    SimpleChanges,
    OnChanges,
    AfterViewInit
} from '@angular/core';
import {
    FormGroup,
    FormBuilder,
    Validators,
    AbstractControl,
    ValidatorFn
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import {
    TravelProductService,
    TravelPackage,
    FareTypeChangedEvent
} from '../../../services/travel-product.service';
import {
    Booking,
    Inclusion,
    Package,
    Location,
    Addon,
    AddonOption,
    Sector,
    Totals,
    OptionValueEntityInstance
} from '../../../models/booking.model';
import {
    ActionUpdaterService,
    ApiError
} from '../../../services/action-updater.service';
import {
    LocalStorageService,
    AvailabilityExtras
} from '../../../services/local-storage.service';
import { Availability, ProductUrl, Stop } from '../../../models/availability.model';
import { RunningDogModalComponent } from '../../running-dog-modal/running-dog-modal.component';
import {
    ReferenceDataService,
    StopItem
} from '../../../services/reference-data.service';
import { returnDateValidator } from './return-date.validator';

import * as _ from 'lodash';
import * as moment from 'moment';
import {
    BookingService,
    DeleteSectorByGuidOptions
} from 'app/shared/services/booking.service';
import { Observable } from 'rxjs/Rx';
import { ProductTypeUrl } from 'app/shared/models/enums/ProductTypeUrl.enum';
import { ITINERARY_CONTEXT } from '../../../models/enums/context.enum';
import {
    AvailabilityOption,
    TravelLeg
} from 'app/shared/models/timetables.model';
import { TravelService } from 'app/shared/services/travel.service';
import { DeviceService } from '../../../services/device.service';
import { Dictionary } from 'app/shared/models/dictonary.model';
import { GxConstants } from 'app/shared/constants/gx.constants';
import { encodeUriFragment } from '@angular/router/src/url_tree';
import { SectorAddonsService } from '../../../../shared/services/sector-addons.service';

@Component({
    selector: 'gaweb-travel-dates',
    templateUrl: './travel-dates.component.html'
})

export class TravelDatesComponent implements OnInit {
    @ViewChild(RunningDogModalComponent) runningDogModalComponent;
    @Output() onParentBookingChanged: EventEmitter<any> = new EventEmitter();
    @Output() onDoLaterDateChanged: EventEmitter<any> = new EventEmitter();
    @Input() addons: Array<Addon>;
    @Output() onTravelDatesAddonsChanged: EventEmitter<Array<AddonOption>> = new EventEmitter();
    private _bookings: Array<Booking>;

    @Input()
    set bookings(value: Array<Booking>) {
        this._bookings = value;
        if (value && value.length > 0) {
            this.parentBooking = value[0];
            if (this.parentBooking.Sectors == null) {
                this.parentBooking.Sectors = [];
            }
            this.travelService.getStops().then(data => {
                this.stops = data;
                this.buildForm(false);
            });
        }
    }

    get bookings(): Array<Booking> {
        return this._bookings;
    }
    parentBooking: any;
    deletingSectors = false;
    @Input() showBookTravelSection: boolean;
    @Input() showTripDetails = true;
    @Input() showShortTravelDatesDescription: boolean;
    @Input() showTypeAhead: boolean;
    showJustSectors: boolean;
    ProductTypeUrl = ProductTypeUrl;
    isMyGreyhound: boolean;
    private _context: ITINERARY_CONTEXT;
    @Input()
    set context(c: ITINERARY_CONTEXT) {
        this._context = c;
        this.isMyGreyhound = c === ITINERARY_CONTEXT.MY_GREYHOUND;
    }
    get context(): ITINERARY_CONTEXT {
        return this._context;
    }
    private _productUrl: ProductUrl;
    @Input()
    set productUrl(value: ProductUrl) {
        this._productUrl = value;
        this.showJustSectors =
            this._productUrl.ProductTypeUrl === ProductTypeUrl.expressBooking;
    }
    get productUrl(): ProductUrl {
        return this._productUrl;
    }
    @Input() passengerCounts: Dictionary<FareTypeChangedEvent>;
    @Output()
    showBookTravelSectionChange: EventEmitter<boolean> = new EventEmitter<
        boolean
    >();
    travelForm: FormGroup;
    minDate: Date;
    productTypeName: string;
    public config = {
        animated: true,
        keyboard: true,
        backdrop: false,
        ignoreBackdropClick: true
    };
    addTravelDisabled: boolean;
    doThisLaterCheck: boolean;
    removeTravel: boolean;

    destinations: Array<any>;
    origins: Array<any>;

    stops: Array<StopItem>;
    alertsAvailability: Array<ApiError>;
    refreshSectorAddons: boolean;

    @Input() openAddons: Array<Addon>;

    addonsToPurchase: Array<Addon> = [];
    loadingCartTotal: boolean;

    constructor(
        private fb: FormBuilder,
        private actionUpdaterService: ActionUpdaterService,
        private localStorageService: LocalStorageService,
        private travelService: TravelService,
        private router: Router,
        public travelPackageService: TravelProductService,
        private referenceDataService: ReferenceDataService,
        private activatedRoute: ActivatedRoute,
        private bookingService: BookingService,
        private sectorAddonsService: SectorAddonsService,
        private deviceService: DeviceService
    ) {
        this.addTravelDisabled = false;
    }

    ngOnInit() {
        const that = this;
        this.travelForm = this.fb.group(
            {
                fromStop: [null, Validators.required],
                toStop: [null, Validators.required],
                isReturn: [false, Validators.required],
                departureDate: [this.minDate, Validators.required],
                returnDate: this.minDate
            },
            { validator: returnDateValidator }
        );
        this.activatedRoute.queryParams.subscribe((params: any) => {
            this.removeTravel = params.removeTravel;
            if (params.addTravel === 'true' && this.parentBooking.ShowAddTravelBtn === true) {
                this.setBookTravelSection(true);
            }
            // Clear out used params
            const cleanUrl = this.router.url.replace(
                new RegExp('.removeTravel=' + params.removeTravel),
                ''
            );
            that.router.navigateByUrl(cleanUrl);
            that.router.navigate([], {queryParams: {addTravel: null}, queryParamsHandling: 'merge'});
        });
        this.minDate = moment()
            .startOf('day')
            .toDate();

        this.buildForm(true);
        this.localStorageService.removePackageTravelOptions();
        this.parentBooking.Sectors.forEach(sector => {
            sector.WifiSectors = [];
            if (sector.HasWifi === true) {
                sector.WifiSectors.push(
                    sector['ServiceCompany'] + sector['ServiceNumber']
                );
            }
        });
        this.sectorAddonsService.refreshSectorAddons.subscribe(refresh => this.refreshSectorAddons = refresh);
        this.sectorAddonsService.addonCart.subscribe(addons => this.addonsToPurchase = addons);
        this.sectorAddonsService.loadingCartTotal.subscribe(lct => this.loadingCartTotal = lct);
        this.bookingService.bookings.subscribe(bookings => this.bookings = bookings);
    }

    guidToId(guid: string): string {
        return guid.replace(/-/g, '');
    }

    setBookTravelSection(bool: boolean) {
        // bool is always true
        this.showBookTravelSection = bool;
        this.showBookTravelSectionChange.emit(this.showBookTravelSection);
    }

    buildForm(buildEmptyForm: boolean) {
        this.travelService.getStops().then(data => {
            this.stops = data;
            if (buildEmptyForm && !this.travelForm) {
                this.travelForm = this.fb.group(
                    {
                        fromStop: [null, Validators.required],
                        toStop: [null, Validators.required],
                        isReturn: [false, Validators.required],
                        departureDate: [this.minDate, Validators.required],
                        returnDate: this.minDate
                    },
                    { validator: returnDateValidator }
                );
                return;
            }
            const packageTravelOptions = this.localStorageService.getPackageTravelOptions();
            let fromStopCode: string = null,
                toStopCode: string = null;
            if (!!packageTravelOptions && !!this.parentBooking) {
                fromStopCode = packageTravelOptions.from;
                toStopCode = this.parentBooking.Package.DestinationLocationCode;
                if (toStopCode == null) {
                    toStopCode = packageTravelOptions.to;
                }
            }
            if (
                this.parentBooking.Package != null &&
                this.parentBooking.Package.Locations != null &&
                this.parentBooking.Package.Locations.length > 0
            ) {
                this.destinations = this.parentBooking.Package.Locations.filter(
                    x => x.IsDestination
                );
                this.origins = this.parentBooking.Package.Locations.filter(
                    x => x.IsDeparture
                );
            }
            if (
                !!packageTravelOptions &&
                !!this.travelForm &&
                !!fromStopCode &&
                !!toStopCode
            ) {
                this.travelForm.setValue({
                    fromStop: this.stops.find(x => x.Code === fromStopCode),
                    toStop: this.stops.find(x => x.Code === toStopCode),
                    isReturn: packageTravelOptions.isReturn,
                    departureDate: packageTravelOptions.departureDate,
                    returnDate: packageTravelOptions.returnDate
                });
            } else if (
                !!packageTravelOptions &&
                !this.travelForm &&
                !!fromStopCode &&
                !!toStopCode
            ) {
                this.travelForm = this.fb.group(
                    {
                        fromStop: [
                            this.stops.find(x => x.Code === fromStopCode),
                            Validators.required
                        ],
                        toStop: [
                            this.stops.find(x => x.Code === toStopCode),
                            Validators.required
                        ],
                        isReturn: [
                            packageTravelOptions.isReturn,
                            Validators.required
                        ],
                        departureDate: [
                            packageTravelOptions.departureDate,
                            Validators.required
                        ],
                        returnDate: packageTravelOptions.returnDate
                    },
                    { validator: returnDateValidator }
                );
            } else if (
                !!this.parentBooking &&
                !!this.travelForm &&
                !!this.productUrl.ProductTypeUrl &&
                this.productUrl.ProductTypeUrl !==
                    ProductTypeUrl.expressBooking &&
                !this.showTypeAhead
            ) {
                if (this.parentBooking.length) {
                    this.parentBooking = this.parentBooking[0];
                  }
                const mainObj = Booking.getMainObject(
                    this.parentBooking,
                    this.productUrl.ProductTypeUrl,
                    true
                );

                fromStopCode = mainObj.PrimaryLocationCode;
                toStopCode = mainObj.DestinationLocationCode;
                const isReturn = !mainObj.OneWayTravel;
                const departureDate = mainObj.SuggestedDepDate;
                const returnDate = mainObj.SuggestedRetDate;

                this.travelForm.patchValue({
                    fromStop: this.stops.find(x => x.Code === fromStopCode),
                    toStop: this.stops.find(x => x.Code === toStopCode),
                    isReturn: isReturn,
                    departureDate: departureDate,
                    returnDate: returnDate
                });
            } else if (!this.travelForm) {
                this.travelForm = this.fb.group(
                    {
                        fromStop: [null, Validators.required],
                        toStop: [null, Validators.required],
                        isReturn: [false, Validators.required],
                        departureDate: [this.minDate, Validators.required],
                        returnDate: this.minDate
                    },
                    { validator: returnDateValidator }
                );
            }

            if (this.removeTravel) {
                this.deleteAllSectors(true, null, false);
                this.removeTravel = false;
            }

            if (
                this.bookings.length > 0 &&
                this.parentBooking.Sectors.length > 0
            ) {
                this.scrollToSection('gaweb-travel-dates');
            }
        });
    }

    private scrollToSection(selector: string) {
        if (!this.deviceService.IsMobile()) {
            return;
        }

        if (jQuery(selector).length > 0) {
            jQuery('html, body').animate(
                {
                    scrollTop:
                        jQuery(selector).position().top +
                        0 +
                        parseInt(
                            jQuery('.navbar')
                                .css('height')
                                .replace(/\D/g, ''),
                            10
                        )
                },
                500,
                'linear'
            );
        } else {
            console.log(
                `Couldn't find any element matching selector ` +
                    `selector` +
                    ` to scroll to.`
            );
        }
    }

    private getMatchingStopItem(codeOrLocation: string | Location | StopItem): StopItem {
        if (typeof codeOrLocation !== 'object') {
            const code = codeOrLocation;
            codeOrLocation = new Location();
            codeOrLocation.Code = code;
        }

        if (codeOrLocation instanceof StopItem) {
            return codeOrLocation;
        }

        if (this.parentBooking.Pass != null) {
            if (this.parentBooking.Pass.LimitedStops === true) {
                let location = null;
                if (codeOrLocation instanceof Location) {
                    location = this.parentBooking.Pass.Locations.find(
                        (l: Location) =>
                            l.Code === (codeOrLocation as Location).Code
                    );
                } else {
                    location = this.parentBooking.Pass.Locations.find(
                        (l: Location) =>
                            l.Code === codeOrLocation
                    );
                }

                const stopItem = new StopItem();
                stopItem.Code = location.Code;
                stopItem.Description = location.Description;
                return stopItem;
            } else {
                let result = null;
                if (codeOrLocation instanceof Location) {
                    result = this.stops.find(x => x.Code === (codeOrLocation as Location).Code);
                } else {
                    result = this.stops.find(x => x.Code === codeOrLocation);
                }

                if (result == null) {
                    result = new StopItem();
                    result.Code = codeOrLocation.Code;
                    result.Description = codeOrLocation.Description;
                }

                return result;
            }
        } else {
            let result = null;
            if (codeOrLocation instanceof Location) {
                result = this.stops.find(x => x.Code === (codeOrLocation as Location).Code);
            } else {
                result = this.stops.find(x => x.Code === codeOrLocation);
            }

            if (result == null) {
                result = new StopItem();
                result.Code = codeOrLocation.Code;
                result.Description = codeOrLocation.Description;
            }

            return result;
        }
    }

    private getDestinationStopItem() {
        const stopItem = new StopItem();
        stopItem.Code = this.parentBooking.Package.DestinationLocationCode;
        stopItem.Description = this.parentBooking.Package.DestinationLocationName;

        return stopItem;
    }

    private clearCartItems(booking: Booking){
        if(booking.ProductType != "BP"){
            this.sectorAddonsService.updateAddonsCart(booking, []);
            this.sectorAddonsService.setLoadingCartTotal(false);    
        }
    }

    getAvailability() {
        this.clearCartItems(this.parentBooking);
        const options = this.getAvailabilityOptions();
        const fromCode = this.travelForm.get('fromStop').value;
        const toCode = this.travelForm.get('toStop').value;
        const from = this.getMatchingStopItem(fromCode);
        const to = this.getMatchingStopItem(toCode);

        options.TravelLegs[0].origin = from.Code;
        options.TravelLegs[0].destination = to.Code;

        if (options.TravelLegs.length > 1) {
            options.TravelLegs[1].origin = to.Code;
            options.TravelLegs[1].destination = from.Code;
        }

        this.localStorageService.currentAvailabilityOptions = options;
        this.localStorageService.savePackageTravelOptions(options, to, from);

        this.runningDogModalComponent.showModal();

        this.travelService
            .getAvailability(options)
            .subscribe((availability: Array<Availability>) => {
                this.localStorageService.currentAvailability = availability;
                this.localStorageService.saveTravelAvailability(availability);
                this.runningDogModalComponent.hideModal();

                const packageRef = !!this.travelPackageService.currentProduct
                    ? this.travelPackageService.currentProduct.packageReference
                    : this.parentBooking.Package.PackageReference;
                const availabilityExtras = new AvailabilityExtras();
                availabilityExtras.bookingGuid = this.parentBooking.BookingGuid;
                availabilityExtras.productReference = packageRef;
                availabilityExtras.isReturn = !!this.travelForm.get('isReturn')
                    .value;
                availabilityExtras.context = this.context;
                this.localStorageService.saveAvailabilityExtras(
                    availabilityExtras
                );

                var productRef = window.location.pathname.split('/')[1];
                const categoryReference = this.activatedRoute.snapshot.params['category-reference'];
                const productReference = this.activatedRoute.snapshot.params['product-reference'];
                const bookingGuid = availabilityExtras.bookingGuid;
                console.log('productRef b', window.location.pathname);
                console.log('this.productUrl', this.productUrl);
                if (!!this.productUrl.isManageBooking) {
                    if (
                        this.productUrl.ProductTypeUrl ===
                        ProductTypeUrl.package
                    ) {
                        console.log('mb flag b');
                        this.router.navigate(
                            [
                               // `${this.productUrl.ProductAvailability}/${packageRef}/availability`
                              // `${productRef}/${categoryReference}/${productReference}/book-now/${bookingGuid}/availability`
                              
                              'book-a-ticket/travel-passes/availability'
                            ],
                            {
                                queryParams: {
                                    context: ITINERARY_CONTEXT.MY_GREYHOUND
                                }
                            }
                        );
                    } else {
                        console.log('mb flag c');
                        // travel pass
                        this.router.navigate(
                            [
                              //  `${this.productUrl.ProductAvailability}/availability`
                              //`/booking-management/details/${bookingGuid}/availability`
                              'book-a-ticket/travel-passes/availability'
                            //  `/${productRef}/${categoryReference}/${productReference}/book-now/${bookingGuid}/availability`
                            ],
                            {
                                queryParams: {
                                    context: ITINERARY_CONTEXT.MY_GREYHOUND
                                }
                            }
                        );
                    }
                } else {
                    console.log('mb flag a');
                    this.router.navigate([
                        //`${this.productUrl.ProductAvailability}/${packageRef}/availability`
                        `/${productRef}/${categoryReference}/${productReference}/book-now/${bookingGuid}/availability`
                    ]);
                }
            }, this.onErrorAvailability);
    }

    private getAvailabilityOptions(): AvailabilityOption {
        const _setFareBasis = (_options: AvailabilityOption): void => {
            const passengerCountsKeys = this.passengerCounts
                ? Object.keys(this.passengerCounts)
                : [];
            if (passengerCountsKeys.length) {
                let i = 0;
                for (const fareType of passengerCountsKeys) {
                    i++;
                    const fareTypeChangedEvent: FareTypeChangedEvent = this
                        .passengerCounts[fareType];
                    const { count } = fareTypeChangedEvent;
                    const farebasisCode =
                        fareTypeChangedEvent.fareType.farebasis.FarebasisCode;
                    if (i === 1) {
                        options.fareBasis1Code = farebasisCode;
                        options.fareBasis1Count = count;
                    } else if (i === 2) {
                        options.fareBasis2Code = farebasisCode;
                        options.fareBasis2Count = count;
                    } else if (i === 3) {
                        options.fareBasis3Code = farebasisCode;
                        options.fareBasis3Count = count;
                    }
                }
            } else {
                // fallback
                options.fareBasis1Code = !!this.parentBooking.FareBasis.length
                    ? this.parentBooking.FareBasis[0].FarebasisCode
                    : this.parentBooking.Package.FareTypes[0].Farebasis
                          .FarebasisCode;
                options.fareBasis1Count = this.bookings.length;
            }
        };
        const fares = [],
            options = new AvailabilityOption();

        const fromCode = this.travelForm.get('fromStop').value,
            toCode = this.travelForm.get('toStop').value,
            isReturn = this.travelForm.get('isReturn').value,
            departureDate = moment(
                this.travelForm.get('departureDate').value
            ).format('YYYY-MM-DD'),
            returnDate = moment(this.travelForm.get('returnDate').value).format(
                'YYYY-MM-DD'
            );
        _setFareBasis(options);

        options.isReturn = isReturn;
        options.TravelLegs.push(
            new TravelLeg(fromCode, toCode, departureDate, null)
        );

        // RETURN TRIP
        if (isReturn) {
            options.TravelLegs.push(
                new TravelLeg(toCode, fromCode, returnDate, null)
            );
        }

        return options;
    }

    onError = error => {
        this.runningDogModalComponent.hideModal();
        this.actionUpdaterService.announceError(error);
    };
    
    onErrorAvailability = (error: ApiError) => {
        this.runningDogModalComponent.hideModal();
        this.alertsAvailability = [error];
    };

    isFieldValid(field: string): boolean {
        return (
            !this.travelForm.get(field).valid &&
            this.travelForm.get(field).touched
        );
    }

    displayFieldCss(field: string) {
        return this.isFieldValid(field) ? '' : 'has-error';
    }

    onSectorsDeleted(booking: Booking, removeTravelAndStartOver: boolean) {
        if (this.parentBooking.Sectors.length > 0) {
            this.actionUpdaterService.announceSuccess(
                'Trips have been successfully removed.'
            );
        }
        if (this.deviceService.IsMobile()) {
            jQuery('html, body').animate(
                {
                    scrollTop:
                        jQuery('.itinerary').position().top +
                        20 +
                        parseInt(
                            jQuery('.navbar')
                                .css('height')
                                .replace(/\D/g, ''),
                            10
                        )
                },
                500
            );
        }

        this.bookings = [booking];
        const sectorsDeleted = true;
        this.onParentBookingChanged.emit({
            bookings: this.bookings,
            sectorsDeleted,
            removeTravelAndStartOver
        });
    }
    onSectorDeleted(booking: Booking) {
        this.actionUpdaterService.announceSuccess(
            'Trip has been successfully removed.'
        );
        this.bookings = [booking];
        const sectorsDeleted = true;
        this.bookingService.setBooking(booking, true);
    }
    testDeleteSector() {
        console.log('Test Delete Sector');
    }
    onDoLaterDateChecked(checkValue: boolean) {
        if (checkValue) {
            this.showBookTravelSection = false;
            this.addTravelDisabled = true;
        } else {
            this.addTravelDisabled = false;
        }
        this.onDoLaterDateChanged.emit({
            checkValue,
            sectorsAdded: this.parentBooking.Sectors.length > 0
        });
    }

    isCorrect(): boolean {
        return this.doThisLaterCheck || this.parentBooking.Sectors.length > 0;
    }

    async deleteAllSectors(
        showBookTravelSectionV: boolean,
        bookings: Array<Booking> | null,
        removeTravelAndStartOver: boolean
    ) {
        if (!this.parentBooking || !this.parentBooking.Sectors.length) {
            return;
        }
        this.deletingSectors = true;
        const observables: Observable<any>[] = [];
        if (!!bookings) {
            this.bookings = bookings;
        }
        let lastBooking: Booking = this.parentBooking;
        for (const sector of this.parentBooking.Sectors) {
            const opt = new DeleteSectorByGuidOptions(
                this.parentBooking.BookingGuid,
                sector.SectorGuid
            );
            const b = await this.bookingService
                .deleteSectorByGuid(opt)
                .toPromise();
            lastBooking = b;
        }
        this.deletingSectors = false;
        this.onSectorsDeleted(lastBooking, removeTravelAndStartOver);
        if (showBookTravelSectionV && this.showTypeAhead) {
            this.setBookTravelSection(true);
        }
    }

    onDeleteAllSectorsError = error => {
        this.deletingSectors = false;
    };

}



// WEBPACK FOOTER //
// ./src/app/shared/components/itinerary/travel-dates/travel-dates.component.ts